import { Typography } from "@mui/material";
import ArtifactAgentNotCopied from "./ArtifactAgentNotCopied";
import ArtifactAgentVersionLabel from "./ArtifactAgentVersionLabel";

interface Props {
  summary?: string;
  notCopied?: string[];
  version?: number;
  savedAt?: string;
}

const ArtifactAgentSavedReply = ({ summary, notCopied, version, savedAt }: Props) => (
  <>
    {summary && <Typography sx={{ whiteSpace: "pre-wrap" }}>{summary}</Typography>}
    {notCopied && <ArtifactAgentNotCopied lines={notCopied} />}
    {version !== undefined && <ArtifactAgentVersionLabel version={version} savedAt={savedAt} />}
  </>
);

export default ArtifactAgentSavedReply;
